module.exports = __webpack_public_path__ + "static/media/highlight-success.69aa32dc.svg";